import React, { memo, useMemo, useState } from 'react';
import { useLang } from '../../util/lang';
import Modal from '../Modal/modal';
import { Button, Grid } from '@material-ui/core';
import SmileDesignCreateCaseButton from '../../pages/SmileDesign/SmileDesignCreateCaseButton';
import NewAlignerCaseModalButton from './NewAlignerCaseModalButton';
import CreateOrderRetainerButton from './CreateOrderRetainerButton';

// determineWhatCaseCanCreate is object

const CreateNewCaseModalButton = ({
    disable = false,
    ClassProps = undefined,
    determineWhatCaseCanCreate,
    patientId = undefined,
}) => {
    const get = useLang();
    const [isOpen, setIsOpen] = useState(false);
    const isMarieGroup = useMemo(() => {
        let value = JSON.parse(localStorage.getItem('isMarieGroup'));
        return value;
    }, []);

    return (
        <>
            <Button className={ClassProps} onClick={() => setIsOpen(true)} disabled={disable}>
                {get('@PatientInfo.case_info.actionsList.createNewCaseForPatient')}
            </Button>
            <Modal
                className="modal"
                modal="NewCaseModal"
                title={
                    get('@PatientInfo.case_info.actionsList.createNewCaseForPatient') + ' ' + get('@Patients.options')
                }
                open={isOpen}
                handleClose={() => setIsOpen(false)}
                modalSize="md"
                submitButton={false}
            >
                <Grid sm={isMarieGroup ? 12 : false} xs={isMarieGroup ? false : 12} style={{ marginTop: 8 }}>
                    <Grid container alignItems="center" sm={isMarieGroup ? 12 : false} spacing={2}>
                        {determineWhatCaseCanCreate.canCreateAlignerCase && (
                            <NewAlignerCaseModalButton patientId={patientId} />
                        )}
                        {determineWhatCaseCanCreate.canCreateSmileDesignCase && (
                            <SmileDesignCreateCaseButton patientId={patientId} />
                        )}
                        {determineWhatCaseCanCreate.canCreateRetainerCase && (
                            <CreateOrderRetainerButton patientId={patientId} />
                        )}
                    </Grid>
                </Grid>
            </Modal>
        </>
    );
};

export default memo(CreateNewCaseModalButton);
